<template>
  <div>
    <div class="page_index page_shadow content">
        <div class="logoBox">
            <img src="../../../../../public/imgs/cepingreport/logo.png" alt="">
        </div>
        <div class="header">
            <h3>生 涯 测 评 报 告</h3>
            <p>Career Orientation Evaluation Report</p>
        </div>
        <div class="mian">
            <p><span>姓名</span>:<span>王德辉</span></p>
            <p><span>性别</span>:<span>男</span></p>
            <p><span>高考年份</span> : <span>2016</span></p>
        </div>
    </div>
    <div class="page_msg page_shadow content">
         <div class="top_header_box">
            <img src='../../../../../public/imgs/cepingreport/logo.png' alt="" >
            <div class="line_box">
                <p>
                    <img src="../../../../../public/imgs/cepingreport/page_feng.png" alt="">
                    测评背景
                </p>
            </div>
        </div>
        <div class="line_border_title">
                <p>测评背景</p>
                <p class="line"></p>
        </div>
        <div class="page_msg_mian">
            <p>当前高中新课程标准业已实施，新高考改革稳步推进，在升学规划上赋予学生更多的选择权，更加尊重其自我兴趣、认知与个性发展。学科、专业选择的灵活自主化和升学途径的丰富化，让中学生和家长在关注能否考上大学的同时，也更加重视如何选择适配的专业和职业，希望高中阶段的生涯决策能够为理想人生打下坚定基础。面对如此形势，高中生除了努力做好学习成绩准备，还要尽早建立专业及职业目标，让学海泛舟受到生涯期待的指引。</p>
            <p> 研究表明，大学生专业满意度的影响因素包括：专业是否与兴趣等个人特征相符合、专业是否有良好的就业前景等；兴趣爱好是影响专业满意度的重要因素，而一味追求热门与就业前景会降低专业满意度。反观现实，个人特征也是相对更稳定可控的，就业形势常因人才竞争、市场需求变化等而出现不可预测的走向，以职业定专业的做法无法避免专业喜好的偏差，且在一定程度上限制了未来发展的更多可能性。</p>
            <p> 因此，本生涯测评秉持“先专业，后职业”的规划理念，着重从人格特性、职业兴趣和智能水平三大个体特质出发，同时进行个体评估和本科专业类别画像，将结果进行科学匹配，最终得到更加适合参测学生的专业选项；同时，基于最新的标准职业体系，结合参测学生的职业兴趣和价值观，向其推荐高适配性的职业选项；此外了解学生的心理适应性状况，保障生涯底层依托。总体而言，本测评系统立足生涯规划、心理学的理念和方法完成科学搭建，通过个体评估和综合匹配输出准确结果，旨在为中学生的专业填报和职业定向等提供有价值的参考。</p>
        </div>
        <div class="page_img_box">
            <img src='../../../../../public/imgs/cepingreport/page_msg.png' alt="">
        </div>
        <div class="page_msg_footer">
            <p>本报告首先呈现信度信息和测评结果总览，说明报告结果的可应用程度以及推荐专业、推荐职业和人格、智能、兴趣、价值观、心理适应性的主要结果。第一、二部分呈现推荐专业和推荐职业的具体信息，为生涯规划提供重要指引。第三至六部分对人格、能力、职业倾向和心理适应性结果进行详细解读，回顾内部探索结果和生涯规划依据。</p>
        </div>
        <div class="page_msg_footer2">
            <p><span>*</span> 版权声明</p>
            <p>本报告内容属于个人隐私，请注意保密，并须在生涯咨询师等专业人士的指导下使用。</p>
            <p> 本报告的所有权受到版权保护，归北京和气聚力教育科技有限公司所有。</p>
        </div>
    </div>   
  </div>
</template>

<script>
export default {
    data(){
        return{
            // headerLogo:''
        }
    }
}
</script>

<style scoped>

.page_index{
    width: 900px;
    height: 1300px;
    background: url(../../../../../public/imgs/cepingreport/cepingReport.png);
    background-size: 900px 1300px;
    position: relative;
    background-size: cover;
}
.logoBox{
    position: absolute;
    width: 140px;
    height: 70px;
    top: 40px;
    left: 50px;
}
.header{
    padding-top: 100px;
    height: 700px;
    text-align: center;
}
.header h3 {
    line-height: 100px;
    font-size: 74px;
    color: #333;
    margin-bottom: 20px;
    font-weight: 600;
}
.header p {
    font-size: 26px;
    line-height: 40px;
    display: inline-block;
    width: 566px;
    text-align: center;
    border-radius: 20px;
    color: #fff;
    background-color: #1CA4B6;
}
.mian{
    margin-top: 200px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
}
.mian p{
    margin-top: 15px;
}

.top_header_box{
    display: flex;
    height: 42px;
    margin-bottom: 40px;
}
.top_header_box .log{
     display: block;
        height: 42px;
}
.top_header_box .line_box{
    padding-top: 20px;
    padding-bottom: 2px;
    flex: 1;
    /* border-bottom: 1px dashed #17ABBD; */
}
.top_header_box .line_box p{
    line-height: 20px;
    float: right;
    display: flex;
    align-items: center;
}
.top_header_box .line_box p img{
    margin-right: 4px;
}
.page_shadow .line_border_title p {
    line-height: 42px;
    color: #2f2f2f;
    font-weight: 500;
    font-size: 30px;
}
.page_shadow .line_border_title .line{
    margin-top: 7px;
    height: 2px;
    width: 150px;
    background: -webkit-gradient(linear,left top,right top,from(#ffb23a),to(#19afbf));
    background: linear-gradient(90deg
,#ffb23a,#19afbf);
}
.page_msg_mian{
    margin-top: 15px;
}
.page_msg_mian p{
    text-indent:2em;
    font-size: 16px;
    font-weight: 400;
    color: #2F2F2F;
    line-height: 26px;
}
.page_img_box{
    display: flex;
    justify-content: center;
    margin-top: 15px;
}
.page_msg_footer,.page_msg_footer2{
    margin-top: 15px;
}
.page_msg_footer p,.page_msg_footer2 p{
    font-size: 16px;
    font-weight: 400;
    color: #2F2F2F;
    line-height: 26px;
}
.page_msg_footer2 span{
    color: red;
}
</style>